import { ISpecialPlacePricing } from './special-place-pricing.model';

export interface ISpecialPlacePricingItem {
  id?: number;
  price?: number;
  pricing?: ISpecialPlacePricing;
}

export class SpecialPlacePricingItem implements ISpecialPlacePricingItem {
  constructor(public id?: number, public price?: number, public pricing?: ISpecialPlacePricing) {}
}

export function getSpecialPlacePricingItemIdentifier(specialPlacePricingItem: ISpecialPlacePricingItem): number | undefined {
  return specialPlacePricingItem.id;
}
